import { api } from './api';
import { fetchResource, updateResource } from './fetchResource';
import { logEvent } from '../helpers/analytics';
import { isEqual } from 'lodash';

export function enroll(data) {
  return dispatch => {
    const { email } = data;
    const body = {
      email: email,
    };
    logEvent('Enrolled');
    return api.post('/api/enrollments', body).then(response => {
      dispatch({ type: 'ENROLLMENT_CONFIRMED', payload: response });
    });
  };
}

export function fetchOnboarding() {
  return dispatch => fetchResource(dispatch, 'onboardings', 'ONBOARDING_FETCHED');
}

export function updateOnboarding(payload) {
  return dispatch => updateResource(dispatch, 'onboardings', payload, 'ONBOARDING_FETCHED');
}

export function updateOnboardingWithStackAndHash(complete = false) {
  return (dispatch, getState) => {
    const { qna_stack, qna_hash } = getState().onboarding;
    return dispatch(updateOnboarding({ qna_stack, qna_hash, complete }));
  };
}

export const addFrameAndKeys = qnaCurrent => ({
  type: 'ADD_FRAME_AND_KEYS',
  frame: qnaCurrent,
});

export const popReviewFramesAndRemoveKeys = index => ({
  type: 'POP_REVIEW_FRAMES_AND_REMOVE_KEYS',
  index,
});

export const setReviewOnIndex = (index, value) => ({
  type: 'SET_REVIEW_ON_INDEX',
  index,
  value,
});

export const markFramesReview = (fromIndex, toIndex, value) => ({
  type: 'MARK_FRAMES_FROM_TO',
  fromIndex,
  toIndex,
  value,
});

export const pathAware = exampleKey => {
  return (dispatch, getState) => {
    const { qna_hash, qna_stack } = getState().onboarding;

    // if the current keys exist in the hash
    if (qna_hash[exampleKey]) {
      // find index of frame that contains key
      const currentIndex = qna_stack.findIndex(frame => frame.keys.includes(exampleKey));
      const current = qna_stack[currentIndex];
      // if the frame with the keys are marked as in review in the stack
      if (current.review) {
        // ensure that previous frames are marked as NOT in review
        const anyPrevFramesInReview = qna_stack.slice(0, currentIndex).reduce((acc, item) => acc || item.review, false);
        if (anyPrevFramesInReview) {
          dispatch(markFramesReview(0, currentIndex, false));
        }
      } else {
        // ensure that previous frames are marked as NOT in review
        dispatch(markFramesReview(0, currentIndex, false));
        // ensure that current & following frames are marked as in review
        dispatch(markFramesReview(currentIndex, qna_stack.length, true));
      }
    } else {
      // how did the user get here?
      //   1. first time visit (GOOD THING™)?
      //     no need to do anything
      //   2. skipped ahead (BAD PANDA)? WTF)
    }
  };
};

/* qnaCurrent is an object of the following format
  {
    questionXKey: {
      question: "what is the meaning of life the universe and everything?",
      answer: 42,
    },
    questionYKey: {
      question: "What are the dependents ages?",
      asnwer: {
        dependent_1: 12,
        dependent_2: 6,
      },
    }
  }
*/
export function continueOnboarding(qnaStack, qnaHash, qnaCurrent, complete = false) {
  // we have to remember answers when user just clicks back and forth without changing answers

  return dispatch => {
    // find index of first frame in review status, returns -1 if there is none
    let firstReviewStackFrameIndex = qnaStack.findIndex(frame => frame.review);

    if (firstReviewStackFrameIndex >= 0) {
      const firstReviewStackFrame = qnaStack[firstReviewStackFrameIndex];
      // compare with values in qnaCurrent
      let equal = true;

      Object.entries(qnaCurrent).forEach(([key, value]) => {
        if (!qnaHash[key]) {
          console.log('The keys and values are not in the hash yet. This should not happen.');
        }
        if (!isEqual(qnaHash[key], value)) {
          equal = false;
        }
      });

      if (equal) {
        // set `review: false` on that frame and leave frame and keys
        dispatch(setReviewOnIndex(firstReviewStackFrameIndex, false));
      } else {
        // pop all frames that had `review: true` from stack and their k-v's from hash, then add new frame
        dispatch(popReviewFramesAndRemoveKeys(firstReviewStackFrameIndex));
        dispatch(addFrameAndKeys(qnaCurrent));
      }
    } else {
      dispatch(addFrameAndKeys(qnaCurrent));
    }
    return dispatch(updateOnboardingWithStackAndHash(complete));
  };
}

export function completeOnboarding(qnaStack, qnaHash, qnaCurrent) {
  return continueOnboarding(qnaStack, qnaHash, qnaCurrent, true);
}

export function backOnboarding(qnaStack) {
  return dispatch => {
    // find the index of the last frame that has `review: false` in qnaStack
    const lastNonReviewIndexRev = qnaStack
      .slice()
      .reverse()
      .findIndex(frame => !frame.review);

    // if it doesn't exist
    if (lastNonReviewIndexRev == -1) {
      console.log('Tried to go back when there is no frame that has `review: false`. This should not happen.');
      return;
    }
    const lastNonReviewIndex = qnaStack.length - 1 - lastNonReviewIndexRev;
    // set `review: true` in the qnaStack at that frame
    dispatch(setReviewOnIndex(lastNonReviewIndex, true));
    return dispatch(updateOnboardingWithStackAndHash());
  };
}
